import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { track } from '@amplitude/analytics-browser'
import { createCertificateAction } from 'src/reducers/certificate/action'
import { Button, Toggle } from 'src/components/app-ui'
import CertificationHeader from '../certification-header'

const useStyles = makeStyles({
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '18px',
    padding: '40px 0',
  },
  illustration: {
    width: 200,
    height: 132,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    borderRadius: '12px',
    background: '#F4F6F8',
    border: '1px solid #E5E7EB',
    color: '#015FFB',
  },
  lines: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
  },
  line: {
    height: 4,
    borderRadius: '2px',
    background: '#D0D5D9',
  },
})

/** Certification before a certificate exists: off switch + create button. */
const CreateCertificate = ({ setCertificateExist }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()

  const handleCreateCertificate = () => {
    if (
      window?.CONSTANTS.USER_ROLE_ID == undefined ||
      window?.CONSTANTS.USER_ROLE_ID == 1
    ) {
      return
    }

    track('created_certificate')
    dispatch(createCertificateAction(id, () => setCertificateExist(true)))
  }

  return (
    <>
      <CertificationHeader
        toggle={<Toggle checked={false} onChange={handleCreateCertificate} />}
      />
      <div className={classes.empty}>
        <div className={classes.illustration}>
          <Icon icon="tabler:award" width={36} height={36} />
          <div className={classes.lines}>
            <div className={classes.line} style={{ width: 72 }} />
            <div className={classes.line} style={{ width: 52 }} />
          </div>
        </div>
        <Button
          variant="outline"
          icon="tabler:plus"
          onClick={handleCreateCertificate}
        >
          Create certificate
        </Button>
      </div>
    </>
  )
}

export default CreateCertificate
